import { User } from '@/interfaces'
import { AttaServices } from '@/services'
import { PropType } from 'vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
//@ts-ignore
import Avataaars from 'vuejs-avataaars'
import { VIcon } from 'vuetify/lib'

@Component({})
export class Avatar extends Vue {
	@Prop({ type: Number, default: 80 }) size!: number
	@Prop({ type: String as PropType<Number | string>, required: false }) userId!: any
	@Prop({ type: String as PropType<Number | string>, required: false, default: null }) preview!: any

	userAvatar = new User.UserAvatar()
	isLoading = true

	async getUserAvatar() {
		if (this.preview) {
			var content = JSON.parse(this.preview)
			this.userAvatar = content || new User.UserAvatar()
			return
		}

		if (!this.userId) return

		this.isLoading = true

		try {
			var response = await AttaServices.getUserAvatarByUserId(this.userId)
			this.userAvatar = response as unknown as User.UserAvatar
		} catch {}
		this.isLoading = false
	}

	mounted() {
		this.getUserAvatar()
	}

	render() {
		return (
			<div
				style={`
                width:${this.size}px;
                height: ${this.size}px;
                align-items: center;
                display: inline-flex;
                justify-content: center;
                letter-spacing: normal;
                line-height: 1;
                position: relative;
                text-indent: 0;
                transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
                vertical-align: middle;
                user-select: none;
            `}
			>
				<Avataaars
					style={`width:${this.size}px; height: ${this.size}px`}
					circleColor={this.userAvatar?.circleColor.length > 0 ? this.userAvatar?.circleColor : null}
					accessoriesType={this.userAvatar?.accessoriesType.length > 0 ? this.userAvatar?.accessoriesType : null}
					clotheType={this.userAvatar?.clotheType.length > 0 ? this.userAvatar?.clotheType : null}
					clotheColor={this.userAvatar?.clotheColor.length > 0 ? this.userAvatar?.clotheColor : null}
					eyebrowType={this.userAvatar?.eyebrowType.length > 0 ? this.userAvatar?.eyebrowType : null}
					eyeType={this.userAvatar?.eyeType.length > 0 ? this.userAvatar?.eyeType : null}
					facialHairColor={this.userAvatar?.facialHairColor.length > 0 ? this.userAvatar?.facialHairColor : null}
					facialHairType={this.userAvatar?.facialHairType.length > 0 ? this.userAvatar?.facialHairType : null}
					graphicType={this.userAvatar?.graphicType.length > 0 ? this.userAvatar?.graphicType : null}
					hairColor={this.userAvatar?.hairColor.length > 0 ? this.userAvatar?.hairColor : null}
					mouthType={this.userAvatar?.mouthType.length > 0 ? this.userAvatar?.mouthType : null}
					skinColor={this.userAvatar?.skinColor.length > 0 ? this.userAvatar?.skinColor : null}
					topType={this.userAvatar?.topType.length > 0 ? this.userAvatar?.topType : null}
					topColor={this.userAvatar?.topColor.length > 0 ? this.userAvatar?.topColor : null}
				/>
			</div>
		)
	}
}

export default Avatar
